//Actions
export enum ACTION {
  SESSION_ID = "SESSION_ID",
  INITIALIZED = "SESSION_INITIALIZED",
}
